import { type ApmBase, init } from '@elastic/apm-rum';
import { getConfig } from '../config/config';

let apm: ApmBase | undefined;

if (typeof window !== 'undefined') {
	const { FSHR_PUBLIC_ELASTIC_RUM_URL, FSHR_PUBLIC_ELASTIC_RUM_ACTIVE = false } = getConfig();

	apm = init({
		apiVersion: 3,
		serviceName: 'fshr-client',
		serverUrl: FSHR_PUBLIC_ELASTIC_RUM_URL as string,
		active: FSHR_PUBLIC_ELASTIC_RUM_ACTIVE as boolean,
		serviceVersion: '1.0.0',
		transactionSampleRate: 1.0,
		propagateTracestate: true,
	});

	if (FSHR_PUBLIC_ELASTIC_RUM_ACTIVE) {
		const origError = console.error;
		console.error = function (...params) {
			const error = params.length ? params[0] : undefined;
			try {
				if (typeof error === 'string' || error instanceof Error) {
					apm?.captureError(error);
				}
			} finally {
				origError.apply(this, params);
			}
		};
	}
}
export default apm;
